import axios from 'axios';

const client = axios.create({
  baseURL: 'https://itunes.apple.com',
});

const defaultParams = {
  limit: 10,
  country: 'us',
  entity: 'podcast',
};

export default {
  search: (options) => {
    return client
      .get('/search', {
        params: {
          ...defaultParams,
          ...options,
        },
      })
      .then((response) => response?.data?.results || []);
  },
};
